// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import * as z from 'zod'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_DogLiabilityBasicDe = z.object({
  dogs: z.array(
    z.object({
      id: z.string(),
      name: z.string().min(1),
      breeds: z.array(z.object({ breed: z.string().min(1) })),
      breed_size: z.string(),
      breed_type: z.enum(['pedigree', 'crossbreed', 'unknown']),
    })
  ),
  born_on: z.string().min(1),
  deductible_amount: z.coerce
    .string()
    .pipe(z.enum(['0', '150', '300']))
    .pipe(z.coerce.number()),
  number_of_claims_in_last_5y: z.coerce
    .string()
    .pipe(z.enum(['0', '1', '2']))
    .pipe(z.coerce.number()),
})

const Schema_DogLiabilityBasicDe = BaseSchema_DogLiabilityBasicDe

export default Schema_DogLiabilityBasicDe
